// Liste unifiée des sources de référencement utilisée dans :
//  - RegisterPage (inscription startup)
//  - StartupProfile (édition profil)
//  - QIT question 16 (Connaissance de l'événement)
// Les libellés sont stockés en clair (la valeur = le libellé).

export const REFERRAL_SOURCES = [
  'LinkedIn',
  'Mail',
  'Téléphone',
  'Parties prenantes du projet',
  'Bouche-à-oreille',
  'Site LBPAM',
  'Autre',
];

// Anciennes valeurs courtes (avant unification) → nouvelles valeurs en clair.
// Utilisé pour afficher correctement les comptes existants.
const LEGACY_MAP = {
  presse: 'Autre',                   // mappé vers Autre (Presse n'est plus dans la liste)
  internet: 'Autre',                 // idem
  forums_salons: 'Autre',
  demarchage: 'Mail',                // démarchage = mail / téléphone, choisir Mail par défaut
  autre: 'Autre',
  // Anciennes valeurs en clair de la précédente version (11 items)
  'Bouche à oreille': 'Bouche-à-oreille',
  'Forums & Salons': 'Autre',
  'Site internet': 'Autre',
  'Démarchage': 'Mail',
  'Presse': 'Autre',
};

export function migrateLegacyReferral(value) {
  if (!value) return value;
  const trimmed = String(value).trim();
  // If value already starts with "Autre:" (free text version), preserve it
  if (trimmed.startsWith('Autre:') || trimmed.startsWith('Other:')) return trimmed;
  return LEGACY_MAP[trimmed] || trimmed;
}

// Pour les single-select (Register, Profile) :
// la valeur est soit une option de REFERRAL_SOURCES, soit "Autre:<texte libre>".
export function isOtherValue(v) {
  return typeof v === 'string' && (v === 'Autre' || v.startsWith('Autre:') || v.startsWith('Other:'));
}
export function parseReferralValue(v) {
  if (!v) return { option: '', otherText: '' };
  if (v.startsWith('Autre:')) return { option: 'Autre', otherText: v.substring(6).trim() };
  if (v.startsWith('Other:')) return { option: 'Autre', otherText: v.substring(6).trim() };
  return { option: v, otherText: '' };
}
export function buildReferralValue(option, otherText) {
  if (option !== 'Autre') return option;
  const t = (otherText || '').trim();
  return t ? `Autre:${t}` : 'Autre';
}
